export default {
  VISITOR: 'Visitor',
  USER: 'User',
  MENTOR: 'Mentor',
}
